// Types
import { ChannelMonetizationMilestoneType } from 'api/graphql-global-types';
import { MilestoneRow } from './types';

export const MILESTONE_LABELS: Record<
  ChannelMonetizationMilestoneType,
  string
> = {
  [ChannelMonetizationMilestoneType.Followers]: 'Followers',
  [ChannelMonetizationMilestoneType.InterviewStream]: 'Interview / Stream',
  [ChannelMonetizationMilestoneType.InterviewNow]: 'Interview Now',
  [ChannelMonetizationMilestoneType.Mentions]: 'Brand & Athlete Mentions',
  [ChannelMonetizationMilestoneType.GuestInvites]:
    'Invite New Interview Guests',
};

export const DEFAULT_MILESTONES: MilestoneRow[] = [
  {
    type: ChannelMonetizationMilestoneType.Followers,
    target: 50,
    enabled: true,
    displayOrder: 1,
  },
  {
    type: ChannelMonetizationMilestoneType.InterviewStream,
    target: 8,
    enabled: true,
    displayOrder: 2,
  },
  {
    type: ChannelMonetizationMilestoneType.InterviewNow,
    target: 8,
    enabled: true,
    displayOrder: 3,
  },
  {
    type: ChannelMonetizationMilestoneType.Mentions,
    target: 16,
    enabled: true,
    displayOrder: 4,
  },
  {
    type: ChannelMonetizationMilestoneType.GuestInvites,
    target: 4,
    enabled: true,
    displayOrder: 5,
  },
];

export const DEFAULT_PROGRAM_FORM_VALUES = {
  prizeAmount: 500,
  prizeCurrency: 'USD',
  slotsPerMonth: 10,
};

export const MONTH_LABEL_PATTERN = /^\d{4}-\d{2}$/;
